// extracted by mini-css-extract-plugin
export var containerLogo = "styles-module--containerLogo--8wKVb";
export var description = "styles-module--description--uP6g+";
export var descriptionBottom = "styles-module--descriptionBottom--Y6PYs";
export var descriptionContent = "styles-module--descriptionContent--75XsP";
export var descriptionTop = "styles-module--descriptionTop--OWHcE";
export var follow = "styles-module--follow--skWxP";
export var followText = "styles-module--followText--GrWg+";
export var gridContainer = "styles-module--gridContainer--T+bvl";
export var imageBottom = "styles-module--imageBottom--Ot2BB";
export var imageTop = "styles-module--imageTop--ZJg55";
export var linkFacebook = "styles-module--linkFacebook--Brwq0";
export var linkInstagram = "styles-module--linkInstagram--S5m7s";
export var links = "styles-module--links--1y5iT";
export var logo = "styles-module--logo--pls3C";
export var logosContainerFlex = "styles-module--logosContainerFlex--KVq7U";
export var presentation = "styles-module--presentation--2Q9fJ";
export var presentationButton = "styles-module--presentationButton--5ktkK";
export var presentationText = "styles-module--presentationText--g9bcL";
export var presentationTop = "styles-module--presentationTop--RXt7z";
export var valeur = "styles-module--valeur--tRoQD";
export var valeurTitle = "styles-module--valeurTitle--xf1pI";